/** Local capture types for the Procurement Products Allergens/Ingredients/Nutritional Info tabs.
 * These are UI-only for now (no backend persistence exists yet on MarketItem). */

export enum ProductAllergenStatus {
  Contains = 'Contains',
  MayContain = 'MayContain',
  FreeFrom = 'FreeFrom',
}

export interface ProductAllergenEntry {
  allergenId: number;
  status: ProductAllergenStatus;
}

export interface ProductIngredient {
  id: number;
  name: string;
  percentage?: number;
  sortOrder: number;
}

export interface NutritionalValues {
  energyKj?: number;
  energyKcal?: number;
  fat?: number;
  saturates?: number;
  carbohydrate?: number;
  sugars?: number;
  fibre?: number;
  protein?: number;
  salt?: number;
}

export interface ProductNutritionalInfo {
  servingSize?: string;
  per100g: NutritionalValues;
  perServing: NutritionalValues;
}

export const emptyNutritionalInfo: ProductNutritionalInfo = {
  servingSize: '',
  per100g: {},
  perServing: {},
};
